export const VARIANTS = {
	header: {
		hidden: { opacity: 0, y: -100 },
		show: { opacity: 1, y: 0 },
		timing: { type: "spring", duration: 1, delay: 1 },
	},
};
